import React, { useCallback } from "react";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";
import { useUpgradeModal } from "@rapid/contexts/UpgradeModalContext";

interface OutOfCreditsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const OutOfCreditsModal: React.FC<OutOfCreditsModalProps> = ({ isOpen, onClose }) => {
    const { openUpgradeModal } = useUpgradeModal();

    const handleUpgrade = useCallback(() => {
        openUpgradeModal("rapid-out-of-credits");
        onClose();
    }, [openUpgradeModal, onClose]);

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={handleUpgrade}
            type="warning"
            size="md"
            icon="far fa-credit-card"
            title="Out of Credits"
            submitButtonText="Upgrade Plan"
            cancelButtonText="Close"
            submitButtonProps={{ type: "primary" }}
        >
            <div className="flex flex-col gap-3 text-center">
                <p>You've used all your available credits for this workspace.</p>
                <p>
                    To continue testing your model, please upgrade your plan or wait for your
                    credits to renew.
                </p>
            </div>
        </ModalWithIcon>
    );
};
